import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { AppointmentDataService, AppointmentModel, Clinic, ProductModel, StudyModel } from '@mmx/shared'

import { ProductDialogComponent } from '../product-dialog'

@Component({
  selector: 'mmx-procedures-card',
  templateUrl: './procedures-card.component.html',
  styleUrls: ['./procedures-card.component.scss'],
  standalone: false,
})
export class ProceduresCardComponent implements OnChanges {
  @Input() public appointment: AppointmentModel
  @Input() public products: ProductModel[]
  @Input() public clinic: Clinic
  @Input() public editable = true

  selectedProducts: ProductModel[] = []
  displayedColumns = ['name', 'eid', 'procedureCodes', 'diagnosisCodes']
  transformedStudies: StudyModel[] = []

  constructor(
    public data: AppointmentDataService,
    private dialog: MatDialog,
  ) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.appointment || changes.products){
      this.updateTransformedStudy()
    }
  }

  public openEditProduct(study: StudyModel): void {
    const product = study.product
    this.dialog
      .open(ProductDialogComponent, {
        panelClass: 'dialog-form',
        width: '900px',
        data: {
          product,
          fromProceduresCard: true,
        },
      })
      .afterClosed()
      .subscribe((updatedProduct?: ProductModel) => {
        if (updatedProduct) {
          // pull appointments again to get updated information
          this.data.appointmentUpdated$.next()
        }
      })
  }

  private updateTransformedStudy(){
    if (this.appointment?.studies?.length > 0 && this.products?.length > 0) {
      this.transformedStudies = this.appointment.studies.flatMap(study => {
        return StudyModel.build(study, this.products)
      })

      // look for any products on the appointment not on a study
      const studyProducts = new Set(this.appointment.studies.flatMap(study => study.products))

      this.products.forEach(product => {
        if (!studyProducts.has(product.id)) {
          const fakeStudy = new StudyModel({
            products: [product.id],
            productCategories: product.categories,
          }, product)
          this.transformedStudies.push(fakeStudy)
        }
      })
    } else {
      this.transformedStudies = []
    }
  }
}
